import { service } from '@ember/service';
import RequestBaseRoute from './base';

export default class RequestChannel extends RequestBaseRoute {
  @service request;

  beforeModel() {
    let reservation = this.modelFor(this.request.baseRouteName);

    if (!reservation.clientType && !reservation.channel?.hasPrescreenerQuestions) {
      this.request.transitionTo(this, 'client-type');
    }
  }

  setupController(controller, model, transition) {
    super.setupController(controller, model, transition);
    let reservation = this.modelFor(this.request.baseRouteName);
    controller.setProperties({
      hideConfirmationNote: !!reservation.channel?.hasPrescreenerQuestions,
      isCreditCardRequired: reservation.isCreditCardRequired,
    });
  }
}
